<template>
  <aside :id="sectionId" class="clinic-booking" :aria-label="title">
    <h2 class="clinic-booking__title">{{ title }}</h2>
    <div class="clinic-booking__actions">
      <ClinicAppointmentButton
          class="clinic-detail-cta"
          :clinic="clinic"
          text="Записаться"
          isDetail
      />
      <ClinicCallButton :clinic="clinic" source="detail" classList="clinic-booking__ghost"/>
    </div>
    <div class="clinic-booking__meta">
      <p
          v-if="clinic.schedule"
          class="clinic-booking__row"
          :class="{'clinic-booking__row--accent': clinic.isAlwaysOpen}"
          v-html="sanitizeHtml(clinicSchedulePlain(clinic.schedule))"
      />
      <p v-if="clinic.address" class="clinic-booking__row">{{ clinic.address }}</p>
    </div>
    <details class="clinic-booking__how">
      <summary>Как проходит запись?</summary>
      <p>Заявка уходит в клинику. Администратор подтверждает время. Запись на слот — у врача или услуги, если у них есть расписание.</p>
    </details>
  </aside>
</template>

<script lang="ts" setup>
import type {TClinicDetail} from '~/types/clinic';
import {sanitizeHtml} from '~/utils/sanitizeHtml';
import {clinicSchedulePlain} from '~/utils/clinicScheduleLabel';

withDefaults(defineProps<{
  clinic: TClinicDetail;
  sectionId?: string;
  title?: string;
}>(), {
  sectionId: 'book',
  title: 'Записаться в клинику',
});
</script>

<style lang="scss">
.clinic-booking {
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-sizing: border-box;
  width: 100%;
  padding: 24px;
  background: $color-white;
  border-radius: 24px;
  box-shadow: 0 4px 10px 0 rgba(138, 138, 176, 0.07);

  &__title {
    margin: 0;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.3;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .button {
      width: 100%;
    }
  }

  &__ghost {
    width: 100%;
    background-color: $color-pink;
    border-color: transparent;
    color: $color-accent-text;

    &:hover {
      background-color: tint($color-purple, $color-white, 17%);
      border-color: transparent;
      color: $color-accent-text;
    }
  }

  &__meta {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__row {
    margin: 0;
    color: $color-gray;
    font-size: 14px;
    line-height: 1.35;
    white-space: pre-line;

    &--accent {
      color: $color-accent-text;
      font-weight: 500;
    }
  }

  &__how {
    border-top: 0.5px solid $color-light-gray;
    padding-top: 12px;

    summary {
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      color: $color-accent-text;
    }

    p {
      margin: 8px 0 0;
      font-size: 14px;
      line-height: 1.35;
      color: $color-gray;
    }
  }
}
</style>
